module.exports = __webpack_public_path__ + "static/media/samsung-aife-2021-board-1.25d4268c.webp";